import CheckboxInput from './CheckboxInput';

export { type CheckboxInputProps } from './CheckboxInput';
export default CheckboxInput;
